/* Coore – menu drawer: only one top-level category open at a time.
   Works for the theme's own menu (<details>) and the Qikify menu (.tmenu_item--root). */
(function () {
  // Theme menu (<details> accordion)
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open || !d.closest('#menu-drawer')) return;
    var li = d.parentElement, ul = li && li.parentElement;
    if (!ul) return;
    ul.querySelectorAll(':scope > li > details[open]').forEach(function (o) {
      if (o === d) return;
      o.removeAttribute('open');
      o.classList.remove('menu-opening');
      var s = o.querySelector(':scope > summary');
      if (s) s.setAttribute('aria-expanded', 'false');
    });
  }, true);

  // Qikify menu
  var busy = false;
  function isOpen(item) {
    var sub = item.querySelector(':scope > [class*="tmenu_submenu"], :scope > div > [class*="tmenu_submenu"]');
    if (!sub) return false;
    var r = sub.getBoundingClientRect();
    return r.height > 2 && getComputedStyle(sub).display !== 'none' && getComputedStyle(sub).visibility !== 'hidden';
  }
  function toggleOf(item) {
    return item.querySelector(':scope > .tmenu_item_link .tmenu_indicator, :scope > .tmenu_indicator, :scope > .tmenu_item_link [class*="tmenu_indicator"], :scope > [class*="tmenu_indicator"]');
  }
  document.addEventListener('click', function (e) {
    if (busy) return;
    var root = e.target.closest && e.target.closest('.tmenu_item--root');
    if (!root) return;
    var nav = root.parentElement;
    if (!nav) return;
    setTimeout(function () {
      if (!isOpen(root)) return;
      busy = true;
      Array.prototype.forEach.call(nav.children, function (other) {
        if (other === root || !other.classList || !other.classList.contains('tmenu_item--root')) return;
        if (!isOpen(other)) return;
        var t = toggleOf(other);
        if (t) t.click();
      });
      busy = false;
    }, 60);
  }, true);

  // Product cards: rebuild the price as  [main price (green)] [RRP crossed out] [-xx%]
  // Reads whatever price is actually showing (so dealer prices from the wholesale app are used).
  function moneyNum(t){ var m=(t||'').replace(/,/g,'').match(/(\d+(?:\.\d+)?)/); return m?parseFloat(m[1]):NaN; }
  function struck(el, stop){
    for (var n=el; n && n!==stop; n=n.parentElement){
      if (n.tagName==='S' || n.tagName==='DEL') return true;
      var d=getComputedStyle(n).textDecorationLine || getComputedStyle(n).textDecoration || '';
      if (d.indexOf('line-through')>-1) return true;
    }
    return false;
  }
  function shown(el){ return el.getClientRects().length>0 && getComputedStyle(el).visibility!=='hidden'; }
  function buildPrice(box){
    var pr=box.querySelector('.price'); if(!pr) return;
    var was=null, now=null;
    pr.querySelectorAll('*').forEach(function(el){
      if (el.children.length) return;
      var t=(el.textContent||'').trim(); if(!/\d/.test(t) || !/\$/.test(t)) return;
      if (!shown(el)) return;
      if (el.closest('.visually-hidden')) return;
      var v=moneyNum(t); if(isNaN(v)) return;
      if (struck(el, pr)) { if(!was) was={t:t,v:v}; } else { now={t:t,v:v}; }
    });
    if (!now) return;
    var out=box.querySelector('.coore-price-display');
    if(!out){ out=document.createElement('div'); out.className='coore-price-display'; box.insertBefore(out, box.firstChild); }
    var html='<span class="coore-now">'+now.t+'</span>';
    if (was && was.v>now.v){ html+='<s class="coore-was">'+was.t+'</s><span class="coore-off">-'+Math.round((1-now.v/was.v)*100)+'%</span>'; }
    if (out.innerHTML!==html) out.innerHTML=html;
    box.classList.add('coore-ready');
  }
  function buildAll(){ document.querySelectorAll('.coore-card .coore-card-price').forEach(function(b){ try{ buildPrice(b); }catch(e){} }); }
  var bt; function soon(){ clearTimeout(bt); bt=setTimeout(buildAll,120); }
  document.addEventListener('DOMContentLoaded', function(){
    buildAll(); setTimeout(buildAll,800); setTimeout(buildAll,2500);
    try{ new MutationObserver(function(muts){ for(var i=0;i<muts.length;i++){ var t=muts[i].target; if(t.nodeType===1 && t.closest && t.closest('.coore-price-display')) continue; soon(); return; } }).observe(document.body,{subtree:true,childList:true,characterData:true}); }catch(e){}
  });
  window.addEventListener('load', function(){ setTimeout(buildAll,300); });

  // Inner pages, desktop: nudge the header logo so it sits exactly in the middle of the screen
  function centreLogo(){
    if (document.body.classList.contains('index')) return;
    var logo=document.querySelector('.section-header .header > .header__heading-link, .section-header .header > .header__heading');
    if (!logo) return;
    if (window.innerWidth < 990){ logo.style.removeProperty('--coore-logo-shift'); return; }
    var cur=parseFloat(logo.style.getPropertyValue('--coore-logo-shift'))||0;
    var img=logo.querySelector('img') || logo;
    var r=img.getBoundingClientRect(); if(!r.width) return;
    var delta=(document.documentElement.clientWidth/2) - (r.left + r.width/2);
    if (Math.abs(delta) > 0.5) logo.style.setProperty('--coore-logo-shift', (cur+delta).toFixed(1)+'px');
  }
  document.addEventListener('DOMContentLoaded', function(){ centreLogo(); setTimeout(centreLogo,400); });
  window.addEventListener('load', centreLogo);
  window.addEventListener('resize', function(){ clearTimeout(window.__cl); window.__cl=setTimeout(centreLogo,100); });
})();
